import { render, staticRenderFns } from "./ReferenceSimpleManage.vue?vue&type=template&id=b75d9264&"
import script from "./ReferenceSimpleManage.vue?vue&type=script&lang=js&"
export * from "./ReferenceSimpleManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports